/**
 * Model used by three.js part to create 3d objects binding.
 */
export class BindedModelBase {
    constructor() {
        /**
         * Gets current state type.
         */
        this.appState = 0;
        /**
         * Indicates if the case is readonly.
         */
        this.readonly = false;
        /**
         * Indicates if the registering mode is active in AP view.
         */
        this.isRegisteringClickAP = false;
        /**
         * Indicates if the registering mode is active in lateral view.
         */
        this.isRegisteringClickLT = false;
        /**
         * Indicates if the registering mode is active in AP view. (new tool)
         */
        this.isRegistering2ClickAP = false;
        /**
         * Indicates if the registering mode is active in lateral view. (new tool)
         */
        this.isRegistering2ClickLT = false;
        /**
         * Gets AP calibration ratio.
         */
        this.scaleFactorAP = 1;
        /**
         * Gets lateral calibration ratio.
         */
        this.scaleFactorLT = 1;
        /**
         *
         */
        this.scaleHitboxAP = 1;
        /**
         *
         */
        this.scaleHitboxLT = 1;
        /**
         * Binded variable used to change mesh visibility to generate images for print report.
         */
        this.printState = 0; //override it with enum
        /**
         * Indicates if user is calibrating AP view.
         */
        this.calibratingAP = false;
        /**
         * Indicates if user is calibrating LT view.
         */
        this.calibratingLT = false;
        /**
         * Indicates if anatomical axis will sync translation and rotations.
         */
        this.syncAnatomicalAxis = false;
        /**
         * Indicates if apex is too far from axis in AP view.
         */
        this.apexTooFarAP = false;
        /**
         * Indicates if apex is too far from axis in LT view.
         */
        this.apexTooFarLT = false;
        /**
         * Indicates if osteotomy is too far in AP view.
         */
        this.ostTooFarAP = false;
        /**
         * Indicates if osteotomy is too far in LT view.
         */
        this.ostTooFarLT = false;
        /**
         * Indicates if ring is loaded (only patient garage).
         */
        this.garageRingLoaded = false;
        /**
         * Indicates how many lines should be visible for AP view.
         */
        this.linesMaskAP = 0;
        /**
         * Indicates how many lines should be visible for LT view.
         */
        this.linesMaskLT = 0;
        /**
         * Indicates how many goniometers should be visible for AP view.
         */
        this.goniometersMaskAP = 0;
        /**
         * Indicates how many goniometers should be visible for LT view.
         */
        this.goniometersMaskLT = 0;
        /**
         * Indicates if lines layer is enabled.
         */
        this.layer_lines = true;
        /**
         * Indicates if goniometers layer is enabled.
         */
        this.layer_goniometers = true;
        /**
         * Indicates if labels layer is visible.
         */
        this.layer_labels = true;
        /**
         * Indicates if ViewPlan is being printed.
         */
        this.isViewPlanPrinting = false;
    }
}
export const bindedModelBase = new BindedModelBase();
//# sourceMappingURL=BindedModel.js.map